import { useEffect } from "react";

/** Bun inlines NODE_ENV when it bundles the app: "production" under `bun start`, so this is dropped there. */
export const isDev = process.env.NODE_ENV !== "production";

/**
 * A slim strip across the top in development (`bun dev`, including through the tunnel and the
 * dev add-on), so it's never mistaken for the live app. Also marks the browser tab.
 */
export function DevBanner() {
    useEffect(() => {
        if (!document.title.startsWith("DEV")) document.title = `DEV · ${document.title}`;
    }, []);

    return (
        <div className="shrink-0 bg-amber-300 px-3 py-0.5 text-center text-xs font-semibold text-amber-950">Development</div>
    );
}
